import Vue from 'vue'
import Router from 'vue-router'

//Pages Site Denuncia
import Home from '@/views/site_denuncia/Home'
import AcompanhaDenuncia from '@/views/site_denuncia/Acompanha_Denuncia'
import CriaDenuncia from '@/views/site_denuncia/Cria_Denuncia'
import BaseDenuncia from '@/views/site_denuncia/BaseDenuncia'

//Pages ADM Master
import Login from '@/views/Login'
import BaseAdmMaster from '@/views/adm_master/BaseAdmMaster'
import EsqueceuSenhaAdmMaster from '@/views/adm_master/Esqueceu_Senha'
import SobreAdmMaster from '@/views/Sobre'

import PainelAdmMaster from '@/views/adm_master/painel/Painel'

import DenunciasAdmMaster from '@/views/adm_master/denuncias/Denuncias'
import DetalhesDenunciaAdmMaster from '@/views/adm_master/denuncias/Detalhes_Denuncia'

import EmpresasAdmMaster from '@/views/adm_master/empresas/Empresas'
import CriaEmpresaAdmMaster from '@/views/adm_master/empresas/Cria_Empresa'
import DetalhesEmpresaAdmMaster from '@/views/adm_master/empresas/Detalhes_Empresa'

import UnidadesAdmMaster from '@/views/adm_master/unidades/Unidades'
import CriaUnidadeAdmMaster from '@/views/adm_master/unidades/Cria_Unidade'
import DetalhesUnidadeAdmMaster from '@/views/adm_master/unidades/Detalhes_Unidade'

import UsuariosAdmMaster from '@/views/adm_master/usuarios/Usuarios'
import CriaUsuarioAdmMaster from '@/views/adm_master/usuarios/Cria_Usuario'
import DetalhesUsuarioAdmMaster from '@/views/adm_master/usuarios/Detalhes_Usuario'

//Pages ADM Empresa
import BaseAdmEmpresa from '@/views/adm_empresa/BaseAdmEmpresa';
import LoginAdmEmpresa from '@/views/adm_empresa/LoginAdmEmpresa';
import EsqueceuSenhaAdmEmpresa from '@/views/adm_empresa/Esqueceu_Senha'
import SobreAdmEmpresa from '@/views/Sobre'

import PainelAdmEmpresa from '@/views/adm_empresa/painel/Painel'

import DenunciasAdmEmpresa from '@/views/adm_empresa/denuncias/Denuncias'
import DetalhesDenunciaAdmEmpresa from '@/views/adm_empresa/denuncias/Detalhes_Denuncia'

import UnidadesAdmEmpresa from '@/views/adm_empresa/unidades/Unidades'
import DetalhesUnidadeAdmEmpresa from '@/views/adm_empresa/unidades/Detalhes_Unidade'

import UsuariosAdmEmpresa from '@/views/adm_empresa/usuarios/Usuarios'
import DetalhesUsuarioAdmEmpresa from '@/views/adm_empresa/usuarios/Detalhes_Usuario'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/esqueceu_senha',
      name: 'EsqueceuSenhaAdmMaster',
      component: EsqueceuSenhaAdmMaster
    },
    {
      path: '/login',
      name: 'LoginAdmEmpresa',
      component: LoginAdmEmpresa
    },
    {
      path: '/login/esqueceu_senha',
      name: 'EsqueceuSenhaAdmEmpresa',
      component: EsqueceuSenhaAdmEmpresa
    },
    {
      path: '/denuncia/',
      component: BaseDenuncia,
      children: [ 
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: 'criar-denuncia',
          name: 'CriaDenuncia',
          component: CriaDenuncia
        },
        {
          path: 'acompanhar-denuncia',
          name: 'AcompanhaDenuncia',
          component: AcompanhaDenuncia
        }
      ]
    },
    {
      path: '/adm_master/',
      name: 'AdmMaster',
      component: BaseAdmMaster,
      children: [
        {
          path: 'painel',
          name: 'PainelAdmMaster',
          component: PainelAdmMaster
        },
        {
          path: 'denuncias',
          name: 'DenunciasAdmMaster',
          component: DenunciasAdmMaster
        },
        {
          path: 'denuncias/:id_denuncia',
          name: 'DetalhesDenunciaAdmMaster',
          component: DetalhesDenunciaAdmMaster
        },
        {
          path: 'empresas',
          name: 'EmpresasAdmMaster',
          component: EmpresasAdmMaster
        },
        {
          path: 'empresas/criar-empresa',
          name: 'CriaEmpresaAdmMaster',
          component: CriaEmpresaAdmMaster
        },
        {
          path: 'empresas/:id_empresa',
          name: 'DetalhesEmpresaAdmMaster',
          component: DetalhesEmpresaAdmMaster
        },
        {
          path: 'unidades',
          name: 'UnidadesAdmMaster',
          component: UnidadesAdmMaster
        },
        {
          path: 'unidades/criar-unidade',
          name: 'CriaUnidadeAdmMaster',
          component: CriaUnidadeAdmMaster
        },
        {
          path: 'unidades/:id_unidade',
          name: 'DetalhesUnidadeAdmMaster',
          component: DetalhesUnidadeAdmMaster
        },
        {
          path: 'usuarios',
          name: 'UsuariosAdmMaster',
          component: UsuariosAdmMaster
        },
        {
          path: 'usuarios/criar-usuario',
          name: 'CriaUsuarioAdmMaster',
          component: CriaUsuarioAdmMaster
        },
        {
          path: 'usuarios/:id_user',
          name: 'DetalhesUsuarioAdmMaster',
          component: DetalhesUsuarioAdmMaster
        },
        {
          path: 'sobre',
          name: 'SobreAdmMaster',
          component: SobreAdmMaster
        }  
      ],
    },
    {
      path: '/adm_empresa/',
      name: 'AdmEmpresa',
      component: BaseAdmEmpresa,
      children: [
        {
          path: 'esqueceu_senha',
          name: 'EsqueceuSenhaAdmEmpresa',
          component: EsqueceuSenhaAdmEmpresa
        },
        {
          path: 'painel',
          name: 'PainelAdmEmpresa',
          component: PainelAdmEmpresa
        },
        {
          path: 'denuncias',
          name: 'DenunciasAdmEmpresa',
          component: DenunciasAdmEmpresa
        },
        {
          path: 'denuncias/:id_denuncia',
          name: 'DetalhesDenunciaAdmEmpresa',
          component: DetalhesDenunciaAdmEmpresa
        },
        {
          path: 'unidades',
          name: 'UnidadesAdmEmpresa',
          component: UnidadesAdmEmpresa
        },
        {
          path: 'unidades/:id_unidade',
          name: 'DetalhesUnidadeAdmEmpresa',
          component: DetalhesUnidadeAdmEmpresa
        },
        {
          path: 'usuarios',
          name: 'UsuariosAdmEmpresa',
          component: UsuariosAdmEmpresa
        },
        {
          path: 'usuarios/:id_user',
          name: 'DetalhesUsuarioAdmEmpresa',
          component: DetalhesUsuarioAdmEmpresa
        },
        {
          path: 'sobre',
          name: 'Sobre',
          component: SobreAdmEmpresa
        }
      ]
    }
  ]
})
